if (!customElements.get('offers-banner')) {
    customElements.define('offers-banner', class OfferBanner extends HTMLElement {
        constructor(){
            super();

            this.container = this.closest('.banner-container');

            this.cartOfferText = this.querySelector('[data-offer-text]');

            this.cartOfferData = JSON.parse(this.querySelector('[data-offer-data]').innerText);
            
            try{
                this.initMessage();
            }
            catch(e){
                console.log(e)
                document.addEventListener('DOMContentLoaded', () => {
                    this.initMessage();
                })
            }
        }
        initMessage(){
            let geo = Shopify.country != undefined ? Shopify.country : 'GB';
            this.cartOfferData.messages.forEach(mess => {
                if(mess.type == 'shipping'){
                    if(mess.location == 'gb' && geo != 'GB'){
                        mess.enabled = false;
                    }
                    else if(geo =='GB' && mess.location != 'gb'){
                        mess.enabled = false;
                    }
                }
                if(mess.type == 'free_gift'){
                    let freeGiftObject = document.querySelector('free-gift-offer');
                    if(freeGiftObject != null){
                        if(typeof freeGiftObject.getOfferBannerData == 'function'){
                            let freeGiftOfferBannerData = freeGiftObject.getOfferBannerData();
                            if(freeGiftOfferBannerData.length > 0){
                                let firstEnabled = freeGiftOfferBannerData.find(offer => offer.enabled);
                                if(firstEnabled != undefined){
                                    mess.enabled = true;
                                    mess.message = firstEnabled.message;
                                }
                            }
                        }
                        else{
                            throw "Free Gift Object not initialised yet. Delaying until DOMContentLoaded..."
                        }
                    }
                }
            })
            let firstEnabledOffer = this.cartOfferData.messages.find(mess => mess.enabled);
            if (firstEnabledOffer != undefined){
                this.cartOfferText.innerHTML = firstEnabledOffer.message;
                this.container.classList.remove('hidden')
            }
            else{
                this.container.classList.add('hidden')
            } 
        }
        refresh(section = 'main-product-banner'){
            let id = document.getElementById(`${section}`).dataset.id;
            if (id != undefined){
                fetch(`${window.location.pathname}?sections=${id}`)
                .then(response => response.json())
                .then(data => {
                    let parsedHtml = new DOMParser().parseFromString(data[id], 'text/html');
                    this.innerHTML = parsedHtml.querySelector(`offers-banner`).innerHTML;
                    this.cartOfferData = JSON.parse(this.querySelector('[data-offer-data]').innerText);
                    this.cartOfferText = this.querySelector('[data-offer-text]');
                    this.initMessage();
                })

            }
        }
    })
}
